import React from "react";
import TextArea from "../../../../components/UI/form/TextArea";
import {checkFeatureAvailability} from "../../../../util/helper";
import {useParams} from "react-router-dom";

const VendorOrderNote = ({errors,register, getValues, setValue, order})=>{
    const params = useParams()
    return (
            <TextArea
                      label={"Vendor Note"}
                      name="vendor_note"
                      errors={errors}
                      disable={checkFeatureAvailability(order, 'default', params) ? false : true}
                      placeholder={"Vendor Note"}
                      register={register}/>
    );
}
export default VendorOrderNote